import React from 'react';
import { parseStyle } from './utils';
// import { BigNumber } from "ethers";
import { APP_TOKEN_ADDRESS, PROVENANCE_HASH } from './constant';

const WebFlow = (props) => {
  const {
    text = 'Connect Wallet',
    onMint,
    onMintFree,
    connected,
    onConnect,
    leftQuantity = '-',
    // price,
  } = props;
  const [itemCount, setItemCount] = React.useState(1);
  const [audio] = React.useState(
    new Audio('https://www.mboxdrive.com/bgm.mp3')
  );
  const [playAudio, setPlayAudio] = React.useState(false);
  const loadScript = async () => {
    const url = '/js/webflow.js';

    let script = document.querySelector(`script[src="${url}"]`);

    if (!script) {
      script = document.createElement('script');
      script.type = 'application/javascript';
      script.src = url;
      script.async = true;
      document.body.appendChild(script);
    }
  };

  React.useEffect(() => {
    loadScript();
  }, []);

  React.useEffect(() => {
    if (!audio) return;
    if (playAudio) {
      audio.play();
    } else {
      audio.pause();
    }
  }, [playAudio, audio]);

  const connectHandler = () => {
    if (!connected) {
      if (onConnect) {
        onConnect();
      }
    }
  };

  const mintHandler = (quantity = itemCount) => {
    if (quantity <= 0) return;
    if (onMint) {
      onMint(quantity).then(() => {
        setItemCount(1);
      });
    }
  };

  const mintFreeHandler = (quantity = itemCount) => {
    if (quantity <= 0) return;
    if (onMintFree) {
      onMintFree().then(() => {
        setItemCount(1);
      });
    }
  };

  // const getPrice = () => {
  //   return parseBalance(BigNumber.from(itemCount.toString()).mul(price));
  // };

  return (
    <React.Fragment>
      {/* <div className="html-embed w-embed"><audio controls="" autoPlay="">
                <source src="https://www.mboxdrive.com/132279_dream-invasion_by_popraz_preview.mp3" type="audio/mpeg" />
                Your browser does not support the audio tag.
            </audio></div> */}
      <div
        style={parseStyle(
          'WebkitTransform:translate3d(0, 0, 0) scale3d(1.25, 1.25, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);MozTransform:translate3d(0, 0, 0) scale3d(1.25, 1.25, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);msTransform:translate3d(0, 0, 0) scale3d(1.25, 1.25, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 0, 0) scale3d(1.25, 1.25, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)'
        )}
        className="bg-overlay bg"
      ></div>
      <div className="bg-overlay lottie">
        <div
          className="lottie-animation"
          data-w-id="1b682dd4-7ec9-14f5-e76d-2162731b2a00"
          data-animation-type="lottie"
          data-src="/documents/10115-birds.json"
          data-loop="1"
          data-direction="1"
          data-autoplay="1"
          data-is-ix2-target="0"
          data-renderer="svg"
          data-default-duration="9"
          data-duration="0"
        ></div>
      </div>
      <div className="body-wrapper">
        <div className="div-block-6">
          <div className="nav">
            {/*eslint-disable jsx-a11y/anchor-is-valid */}
            <a
              data-w-id="d94d1258-1e44-6a80-1056-06ed1a351d93"
              style={parseStyle('opacity:0')}
              onClick={() => setPlayAudio(true)}
              href="#"
              className="button w-button"
            >
              Let me in
            </a>
          </div>
          <div className="main-content">
            <div className="div-block-4">
              <div className="content-wrapper">
                <div style={parseStyle('opacity:0')} className="social-wrapper">
                  <a
                    data-w-id="878d077a-9177-3911-2e9e-c65be6ca1391"
                    href="https://twitter.com/muffinpetsxyz"
                    className="w-inline-block"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="images/twitter.png"
                      loading="lazy"
                      style={parseStyle(
                        'WebkitTransform:translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0);MozTransform:translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0);msTransform:translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0);transform:translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)'
                      )}
                      alt=""
                      className="social"
                    />
                  </a>
                  <a
                    data-w-id="c016ef55-6fa5-64cd-560f-5216390f7f41"
                    href="https://opensea.io/collection/muffinpets"
                    className="w-inline-block"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="images/opensea.png"
                      loading="lazy"
                      alt=""
                      className="social twitter"
                    />
                  </a>
                  <a
                    data-w-id="7e0980f7-1dc5-281c-9dd3-9fc48ff4d689"
                    href="#"
                    onClick={() => setPlayAudio(!playAudio)}
                    className="w-inline-block"
                  >
                    <img
                      src="images/audio.png"
                      loading="lazy"
                      alt=""
                      className="social twitter"
                    />
                  </a>
                </div>
                <div className="div-block-7">
                  {/* eslint-disable-next-line */}
                  <div
                    data-w-id="b38de59d-c359-47d3-ecac-d3dc2cea0c71"
                    style={parseStyle('opacity:0')}
                    className="text-block-2"
                  >
                    We're soft spongy tubes. Stiff when we have to be, but
                    mostly flaccid and nice. We've already eaten up the roadmap.{' '}
                    <br />
                    <br />
                    Wen reveal? Instant.
                    {/* eslint-disable-next-line */}
                    <a
                      href="http://loripsum.net/"
                      rel="noreferrer"
                      target="_blank"
                    ></a>
                  </div>
                  {!connected && (
                    <a
                      data-w-id="2640700f-54b0-48f9-a6c4-b69dd6e80ea8"
                      style={parseStyle('opacity:0')}
                      href="#"
                      onClick={connectHandler}
                      className="connectbutton w-button"
                    >
                      {text}
                    </a>
                  )}
                  <div style={parseStyle('opacity:0')} className="tokensleft">
                    Tokens left:{leftQuantity}
                  </div>
                  <div
                    style={parseStyle(
                      'opacity:0;WebkitTransform:translate3d(0, 100%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);MozTransform:translate3d(0, 100%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);msTransform:translate3d(0, 100%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 100%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)'
                    )}
                    className="w-layout-grid grid"
                  >
                    <div
                      id="w-node-ee661a7d-8c18-e963-42be-d7d1c3974cb2-c3bc5018"
                      className="grid-child"
                    >
                      <img
                        src="images/1st-mint-free.png"
                        loading="lazy"
                        alt=""
                        className="mintimage"
                      />
                      <button
                        data-w-id="39fe8d3d-7e84-0fe6-4cd6-a9496556d07c"
                        disabled={!connected}
                        onClick={() => mintFreeHandler(1)}
                        className="mintbutton w-button"
                      >
                        Mint
                      </button>
                      <div className="mintfreecopy">*1 free per address</div>
                    </div>
                    <div className="grid-child">
                      <img
                        src="images/subsequent-mint.png"
                        loading="lazy"
                        alt=""
                        className="mintimage"
                      />
                      <div className="form-block-2 w-form">
                        <form
                          id="email-form"
                          name="email-form"
                          data-name="Email Form"
                          method="get"
                          className="form"
                        >
                          <input
                            type="number"
                            className="text-field w-input"
                            max={20}
                            min={1}
                            value={itemCount}
                            onChange={(e) => setItemCount(e.target.value)}
                            name="name"
                            data-name="Name"
                            placeholder="1-20"
                            id="name"
                            required=""
                          />
                          <button
                            disabled={!connected}
                            data-wait="Please wait..."
                            className="mintbutton w-button"
                            onClick={() => mintHandler()}
                          >
                            Mint
                          </button>
                        </form>
                      </div>
                      <div className="mintcopy">0.033 eth/NFT</div>
                    </div>
                  </div>
                </div>
                <div
                  style={parseStyle(
                    'opacity:0;WebkitTransform:translate3d(0, 100%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);MozTransform:translate3d(0, 100%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);msTransform:translate3d(0, 100%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 100%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)'
                  )}
                  className="marquee-contrained"
                >
                  <div className="marquee-container">
                    <div className="marquee-wrapper">
                      <div className="row-odd">
                        <div className="pfp-wrapper">
                          <img
                            src="images/1.png"
                            loading="lazy"
                            alt=""
                            className="pfp-iamge"
                          />
                        </div>
                        <div className="pfp-wrapper">
                          <img
                            src="images/2.png"
                            loading="lazy"
                            alt=""
                            className="pfp-iamge"
                          />
                        </div>
                        <div className="pfp-wrapper">
                          <img
                            src="images/3.png"
                            loading="lazy"
                            alt=""
                            className="pfp-iamge"
                          />
                        </div>
                        <div className="pfp-wrapper">
                          <img
                            src="images/4.png"
                            loading="lazy"
                            alt=""
                            className="pfp-iamge"
                          />
                        </div>
                        <div className="pfp-wrapper">
                          <img
                            src="images/5.png"
                            loading="lazy"
                            alt=""
                            className="pfp-iamge"
                          />
                        </div>
                        <div className="pfp-wrapper">
                          <img
                            src="images/6.png"
                            loading="lazy"
                            alt=""
                            className="pfp-iamge"
                          />
                        </div>
                        <div className="pfp-wrapper">
                          <img
                            src="images/13.png"
                            loading="lazy"
                            alt=""
                            className="pfp-iamge"
                          />
                        </div>
                        <div className="pfp-wrapper">
                          <img
                            src="images/14.png"
                            loading="lazy"
                            alt=""
                            className="pfp-iamge"
                          />
                        </div>
                        <div className="pfp-wrapper">
                          <img
                            src="images/15.png"
                            loading="lazy"
                            alt=""
                            className="pfp-iamge"
                          />
                        </div>
                        <div className="pfp-wrapper">
                          <img
                            src="images/16.png"
                            loading="lazy"
                            alt=""
                            className="pfp-iamge"
                          />
                        </div>
                        <div className="pfp-wrapper">
                          <img
                            src="images/17.png"
                            loading="lazy"
                            alt=""
                            className="pfp-iamge"
                          />
                        </div>
                        <div className="pfp-wrapper">
                          <img
                            src="images/18.png"
                            loading="lazy"
                            alt=""
                            className="pfp-iamge"
                          />
                        </div>
                      </div>
                      <div className="row-odd">
                        <div className="pfp-wrapper">
                          <img
                            src="images/1.png"
                            loading="lazy"
                            alt=""
                            className="pfp-iamge"
                          />
                        </div>
                        <div className="pfp-wrapper">
                          <img
                            src="images/2.png"
                            loading="lazy"
                            alt=""
                            className="pfp-iamge"
                          />
                        </div>
                        <div className="pfp-wrapper">
                          <img
                            src="images/3.png"
                            loading="lazy"
                            alt=""
                            className="pfp-iamge"
                          />
                        </div>
                        <div className="pfp-wrapper">
                          <img
                            src="images/4.png"
                            loading="lazy"
                            alt=""
                            className="pfp-iamge"
                          />
                        </div>
                        <div className="pfp-wrapper">
                          <img
                            src="images/5.png"
                            loading="lazy"
                            alt=""
                            className="pfp-iamge"
                          />
                        </div>
                        <div className="pfp-wrapper">
                          <img
                            src="images/6.png"
                            loading="lazy"
                            alt=""
                            className="pfp-iamge"
                          />
                        </div>
                        <div className="pfp-wrapper">
                          <img
                            src="images/13.png"
                            loading="lazy"
                            alt=""
                            className="pfp-iamge"
                          />
                        </div>
                        <div className="pfp-wrapper">
                          <img
                            src="images/14.png"
                            loading="lazy"
                            alt=""
                            className="pfp-iamge"
                          />
                        </div>
                        <div className="pfp-wrapper">
                          <img
                            src="images/15.png"
                            loading="lazy"
                            alt=""
                            className="pfp-iamge"
                          />
                        </div>
                        <div className="pfp-wrapper">
                          <img
                            src="images/16.png"
                            loading="lazy"
                            alt=""
                            className="pfp-iamge"
                          />
                        </div>
                        <div className="pfp-wrapper">
                          <img
                            src="images/17.png"
                            loading="lazy"
                            alt=""
                            className="pfp-iamge"
                          />
                        </div>
                        <div className="pfp-wrapper">
                          <img
                            src="images/18.png"
                            loading="lazy"
                            alt=""
                            className="pfp-iamge"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="mobile-pfp">
                    <div className="w-layout-grid grid-2">
                      <div className="pfp-wrapper">
                        <img
                          src="images/1.png"
                          loading="lazy"
                          alt=""
                          className="pfp-iamge"
                        />
                      </div>
                      <div className="pfp-wrapper">
                        <img
                          src="images/2.png"
                          loading="lazy"
                          alt=""
                          className="pfp-iamge"
                        />
                      </div>
                      <div className="pfp-wrapper">
                        <img
                          src="images/3.png"
                          loading="lazy"
                          alt=""
                          className="pfp-iamge"
                        />
                      </div>
                      <div className="pfp-wrapper">
                        <img
                          src="images/4.png"
                          loading="lazy"
                          alt=""
                          className="pfp-iamge"
                        />
                      </div>
                      <div className="pfp-wrapper">
                        <img
                          src="images/5.png"
                          loading="lazy"
                          alt=""
                          className="pfp-iamge"
                        />
                      </div>
                      <div className="pfp-wrapper">
                        <img
                          src="images/6.png"
                          loading="lazy"
                          alt=""
                          className="pfp-iamge"
                        />
                      </div>
                      <div className="pfp-wrapper">
                        <img
                          src="images/13.png"
                          loading="lazy"
                          alt=""
                          className="pfp-iamge"
                        />
                      </div>
                      <div className="pfp-wrapper">
                        <img
                          src="images/14.png"
                          loading="lazy"
                          alt=""
                          className="pfp-iamge"
                        />
                      </div>
                      <div className="pfp-wrapper">
                        <img
                          src="images/15.png"
                          loading="lazy"
                          alt=""
                          className="pfp-iamge"
                        />
                      </div>
                      <div className="pfp-wrapper">
                        <img
                          src="images/16.png"
                          loading="lazy"
                          alt=""
                          className="pfp-iamge"
                        />
                      </div>
                      <div className="pfp-wrapper">
                        <img
                          src="images/17.png"
                          loading="lazy"
                          alt=""
                          className="pfp-iamge"
                        />
                      </div>
                      <div className="pfp-wrapper">
                        <img
                          src="images/18.png"
                          loading="lazy"
                          alt=""
                          className="pfp-iamge"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <img
                  src="/images/logo.png"
                  loading="lazy"
                  style={parseStyle(
                    'WebkitTransform:translate3d(0, -100%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);MozTransform:translate3d(0, -100%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);msTransform:translate3d(0, -100%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, -100%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0'
                  )}
                  alt=""
                  className="logo"
                />
                <div className="div-block-7">
                  <p className="constants">
                    Contract: {APP_TOKEN_ADDRESS}
                    </p>
                    <p className="constants">
                      This collection has been <u>fully generated</u> prior to its launch. 
                      Provenance hash: {PROVENANCE_HASH}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default WebFlow;
